<template>
    <div class="SiteCreateModal">
        <h1>Add Site</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <SiteForm
                ref="siteForm"
                v-bind.sync="site"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import SiteForm from '@/views/company/site/components/SiteForm';
import siteCreateMixin from '@/mixins/siteCreateMixin';

export default {
    name: 'SiteCreateModal',

    mixins: [siteCreateMixin],

    components: { SiteForm },

    props: {
        onSiteCreated: { type: Function, required: true },
    },

    mounted() {
        this.$analytics.trackModalView(this.$options.name);
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'site',
                model_action: 'create',
            });

            const newSite = await this.createSite();
            if (newSite) {
                this.onSiteCreated(newSite);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'site',
                model_action: 'create_cancel',
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.SiteCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>